import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './Redux/Store';
import App from './App'; // Import your main App component
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { createRoot } from 'react-dom/client'; // New API in React 18

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if using TypeScript
root.render(<Provider store={store}>  
  <App />
   </Provider>);


